export { Text, textStyleSpecs, type TextProps, type TextSize, type TextStyleSpec, type TextColorPalette } from "./Text";
